import React, { Component, Fragment } from "react";
import alasql from "alasql";
import _ from "lodash";
import $ from "jquery";
import colors from "./colors.json";
import Skittle from "../../../../../d3Components/skittlesChart/skittle";

class SkittleHolder extends Component {
  state = {
    yearlyHeading1: [],
    yearlyData1: [],
    monthlyData1: [],
    monthlyHeading1: [],
    containerWidth: 0,
    ch1_DrillDownData: {},
  };
  componentDidMount() {
    this.modifyData({ data: this.props.res });
  }
  componentWillReceiveProps(nextProps) {
    if (JSON.stringify(this.props.res) !== JSON.stringify(nextProps.res)) {
      this.modifyData({ data: nextProps.res });
      this.forceUpdate();
    }
  }

  modifyData = ({ data }) => {
    // alasql data modification
    var pd = data.getPortfolioData;
    // year wise data
    var uniqueDates = alasql("select distinct dt from ?", [pd]);
    var byYear = alasql(
      "select SUBSTRING(dt,1,4) as dt, allocation::NUMBER as allocation, style,fund_asset_class_focus from ?",
      [pd]
    );
    var byAssetClass = alasql(
      "select dt, fund_asset_class_focus,MAX(allocation) as allocation from ? group by dt, fund_asset_class_focus",
      [byYear]
    );
    var byStyle = alasql(
      "select dt,style, MAX(allocation) as allocation from ? group by dt, style",
      [byYear]
    );
    // Month wise data
    var byMonths = alasql(
      "select dt,allocation::NUMBER as allocation, style, fund_asset_class_focus from ?",
      [pd]
    );
    var byAssetClassMonths = alasql(
      "select dt, fund_asset_class_focus,MAX(allocation) as allocation from ? group by dt, fund_asset_class_focus",
      [byMonths]
    );
    var byStyleMonths = alasql(
      "select dt,style, MAX(allocation) as allocation from ? group by dt, style",
      [byMonths]
    );

    // set of colors
    let NewColors = colors;
    // *********functions ********//
    // array of arrays function
    const resultArray = (data, yrs, groupBy_text) => {
      let result = _(data)
        .groupBy(groupBy_text)
        .map((objs, key) => [
          key,
          ...yrs.map(
            (year) =>
              _.sumBy(
                _.filter(objs, (obj) => obj.dt === year),
                "allocation"
              ).toFixed(2) + "%"
          ),
        ])
        .value();
      let symbol = [];
      result.map((d) => {
        symbol.push(symbolRE(getShortSymbol(d[0])));
      });
      result.map((d, i) => {
        d.push(NewColors[i], symbol[i]);
      });
      return result;
    };

    // text splitting
    const getShortSymbol = (str) => {
      return str
        .replace(/\b(\w{1,2})(\w+\s?|\s)/g, "$1 ")
        .toUpperCase()
        .slice(0, -1);
    };
    const symbolRE = (str) => {
      let string = str;
      if (string.toString().length > 6) {
        let j = string.slice(0, 6);
        return j;
      } else {
        return string;
      }
    };
    // unique dates
    const distinct_Dates = (data) => {
      return _.uniqBy(data, "dt").map((obj) => obj.dt);
    };

    // header data
    const getHeader = (yrs) => {
      let temp = ["Asset Class"];
      yrs.map((years) => {
        temp.push(years);
      });
      temp = [...temp, "color code", "short code"];
      return temp;
    };

    // Drill down data function
    const getDrilleDownData = (years, data, txt) => {
      let YearWiseData = { data: {}, header: {} };
      years.forEach((yrs) => {
        YearWiseData.data[yrs] = resultArray(
          alasql(
            `select dt,allocation, ${txt} from ? where dt LIKE "${yrs}%" `,
            [data]
          ),
          alasql(`select distinct dt from ? where dt LIKE "${yrs}%"`, [
            byStyleMonths,
          ]).map((d) => {
            return d.dt;
          }),
          txt
        );
        YearWiseData.header[yrs] = getHeader(
          alasql(`select distinct dt from ? where dt LIKE "${yrs}%"`, [
            byStyleMonths,
          ]).map((d) => {
            return d.dt;
          })
        );
      });
      return YearWiseData;
    };
    //********* CHART1 YEARLY DATA ***********//
    var ch1_years = distinct_Dates(byAssetClass);
    var yearlyData1 = resultArray(
      byAssetClass,
      ch1_years,
      "fund_asset_class_focus"
    );
    // yearlyHeading1 data
    var yearlyHeading1 = getHeader(ch1_years);

    //*** CHART1 MONTHLY DATA ***//
    var uniqueMonths = distinct_Dates(byAssetClassMonths);
    var resultMonthly = resultArray(
      byAssetClassMonths,
      uniqueMonths,
      "fund_asset_class_focus"
    );
    // monthlyHeading1 data
    const monthlyHeading1 = getHeader(uniqueMonths);

    // drillDown data,year and month obj pair
    let YearWiseData1 = getDrilleDownData(
      ch1_years,
      byAssetClassMonths,
      "fund_asset_class_focus"
    );
    let containerWidth = $(".container-fluid").width() / 100;

    this.setState({
      yearlyHeading1,
      yearlyData1,
      monthlyData1: resultMonthly,
      monthlyHeading1,
      containerWidth: containerWidth * 100 - 100,
      ch1_DrillDownData: YearWiseData1,
    });
  };
  render() {
    // **** getting Max length of stack *****
    //  getting altered array
    function get_modifiedArr(arr_data) {
      let arr = [];
      if (arr_data && arr_data[1]) {
        for (let i = 1; i < arr_data[1].length - 2; i++) {
          arr.push(arr_data.map((x) => x[i]));
        }
      }
      return arr;
    }
    //  getting length excluding 0's
    function get_length(exclude) {
      var excluded_data = exclude.map((arr) =>
        arr.filter((el) => el !== "0.00%")
      );
      let len = [];
      excluded_data.map((arr, i) => {
        len.push(arr.length);
      });
      return Math.max(...len);
    }
    const {
      yearlyHeading1,
      yearlyData1,
      containerWidth,
      monthlyHeading1,
      monthlyData1,
      ch1_DrillDownData,
    } = this.state;
    return (
      <Fragment>
        <div>
          {yearlyData1.length > 0 && yearlyHeading1.length > 0 ? (
            <Skittle
              id={"skittler"}
              canvasId={"pa"}
              data={yearlyHeading1.length > 8 ? yearlyData1 : monthlyData1}
              heading={
                yearlyHeading1.length > 8 ? yearlyHeading1 : monthlyHeading1
              }
              height={
                yearlyHeading1.length > 8
                  ? get_length(get_modifiedArr(yearlyData1)) * 24 + 200
                  : get_length(get_modifiedArr(monthlyData1)) * 24 + 200
              }
              width={
                yearlyHeading1.length > 8
                  ? (get_length(yearlyData1) - 2.2) * 120
                  : (get_length(monthlyData1) - 2.2) * 120
              }
              containerWidth={containerWidth}
              displayEmptyBlock={false}
              YearWiseData={ch1_DrillDownData}
            />
          ) : null}
        </div>
      </Fragment>
    );
  }
}

export default SkittleHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Component page/AssetClass/section1/skittleHolder.jsx